import type { AboutServerProps } from '@gik/about/components/About/About';
import { About } from '@gik/about/components/About/About';
import type { FallbackProps } from '@gik/core/api/BaseAPIConfig';
import { ISRRevalidateTimeout, baseFallback } from '@gik/core/api/BaseAPIConfig';
import { withTitle } from '@gik/core/hocs/withTitle';
import { catchSSRError } from '@gik/core/utils/catchSSRError';
import { measureSSRPerformance } from '@gik/core/utils/measureSSRPerformance';
import { getEmployees } from '@/api/employee';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';
import { SWRConfig } from 'swr';

export default function AboutUsPageComp({ fallback }: FallbackProps<AboutServerProps>) {
  return withTitle(
    'About Us',
    <SWRConfig value={{ fallback }}>
      <About />
    </SWRConfig>
  );
}

AboutUsPageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};

async function _getStaticProps() {
  const employees = await getEmployees();

  return baseFallback(
    {
      [employees.key]: await employees.json,
    },
    undefined,
    ISRRevalidateTimeout.extraSlow
  );
}

export const getStaticProps = catchSSRError(measureSSRPerformance(_getStaticProps));
